(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["karussell-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.tweed-lexikon-carousel');
  const slides = document.querySelectorAll('.tweed-lexikon-slide');
  const progressItems = document.querySelectorAll('.tweed-lexikon-progress-item');
  
  if (!carousel || slides.length === 0) return;
  
  // Initialize first slide as active
  slides[0].classList.add('active');
  if (progressItems.length > 0) progressItems[0].classList.add('active');
  
  // Debounce function for scroll events
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }
  
  // Function to update active slide with center detection
  function updateActiveSlide() {
    const carouselRect = carousel.getBoundingClientRect();
    const carouselCenter = carouselRect.left + carouselRect.width / 2;
    
    let closestSlide = null;
    let closestDistance = Infinity;
    
    slides.forEach((slide, index) => {
      const slideRect = slide.getBoundingClientRect();
      const slideCenter = slideRect.left + slideRect.width / 2;
      const distance = Math.abs(slideCenter - carouselCenter);
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSlide = index;
      }
      
      slide.classList.remove('active');
    });
    
    if (closestSlide !== null) {
      slides[closestSlide].classList.add('active');
      
      // Update progress indicators
      progressItems.forEach((item, index) => {
        if (index === closestSlide) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }
  }
  
  // Smooth scroll to center the active slide
  function centerActiveSlide() {
    const activeSlide = document.querySelector('.tweed-lexikon-slide.active');
    if (!activeSlide) return;
    
    const slideLeft = activeSlide.offsetLeft - (carousel.offsetWidth - activeSlide.offsetWidth) / 2;
    
    carousel.scrollTo({
      left: slideLeft,
      behavior: 'smooth'
    });
  }
  
  // Update on scroll with debounce
  carousel.addEventListener('scroll', debounce(function() {
    requestAnimationFrame(updateActiveSlide);
  }, 100));
  
  // Update on resize
  window.addEventListener('resize', debounce(function() {
    requestAnimationFrame(updateActiveSlide);
    requestAnimationFrame(centerActiveSlide);
  }, 150));
  
  // Click on progress items to navigate
  progressItems.forEach((item, index) => {
    item.addEventListener('click', function() {
      const slide = slides[index];
      const slideLeft = slide.offsetLeft - (carousel.offsetWidth - slide.offsetWidth) / 2;
      
      carousel.scrollTo({
        left: slideLeft,
        behavior: 'smooth'
      });
    });
  });
  
  // Initial update
  updateActiveSlide();
  centerActiveSlide();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["priority-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('jc-priority-email-form');
  if (!form) return;

  var formBlock = document.getElementById('jc-priority-form-block');
  var successBlock = document.getElementById('jc-priority-success');
  var successText = successBlock ? successBlock.querySelector('.priority-form__success') : null;
  var errorEl = form.querySelector('.priority-form__error');

  var REVISION = '2024-10-15';
  var LIST_ID = (form.getAttribute('data-klaviyo-list') || '').trim();
  var PUBLIC_KEY = (form.getAttribute('data-klaviyo-key') || '').trim();
  var LANDING_VERSION = form.getAttribute('data-landing-version') || 'priority-2026-05';

  // DOI-Rueckkehr: ?confirmed=1 -> Bestaetigungs-State zeigen
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('confirmed') === '1' && successBlock && successText && formBlock) {
      var confirmedText = successBlock.getAttribute('data-confirmed-text');
      if (confirmedText) successText.textContent = confirmedText;
      formBlock.hidden = true;
      successBlock.hidden = false;
    }
  } catch (e) { /* URLSearchParams nicht verfuegbar — ignorieren */ }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }
  function clearError() {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearError();

    var emailInput = form.querySelector('input[name="email"]');
    var vornameInput = form.querySelector('input[name="vorname"]');
    var email = ((emailInput && emailInput.value) || '').trim();
    var vorname = ((vornameInput && vornameInput.value) || '').trim();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError(({ nl: "Voer een geldig e-mailadres in.", en: "Please enter a valid email address.", fr: "Veuillez saisir une adresse e-mail valide.", it: "Inserisci un indirizzo e-mail valido.", sv: "Ange en giltig e-postadress.", pl: "Prosimy podać prawidłowy adres e-mail." }[document.documentElement.lang.toLowerCase().split('-')[0]] || "Bitte geben Sie eine gültige E-Mail-Adresse ein."));
      return;
    }

    // Fail-closed: ohne List-ID / Public-Key kein echter Submit und KEIN Fake-Erfolg.
    if (!LIST_ID || !PUBLIC_KEY) {
      showError(({ nl: "Aanmelden is momenteel niet mogelijk. Probeer het later opnieuw.", en: "Signing up is not possible at the moment. Please try again later.", fr: "L’inscription n’est pas possible pour le moment. Veuillez réessayer plus tard.", it: "Al momento non è possibile iscriversi. Riprova più tardi.", sv: "Det går inte att anmäla sig just nu. Försök igen senare.", pl: "Zapisanie się nie jest w tej chwili możliwe. Prosimy spróbować ponownie później." }[document.documentElement.lang.toLowerCase().split('-')[0]] || "Die Anmeldung ist gerade nicht möglich. Bitte versuchen Sie es später erneut."));
      console.warn('JC-Priority: klaviyo_list_id oder klaviyo_public_key fehlt — Section-Setting im Theme-Editor ausfüllen.');
      return;
    }

    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    var profileAttrs = {
      email: email,
      properties: { landing_version: LANDING_VERSION, source: 'postcard-priority' }
    };
    if (vorname) profileAttrs.first_name = vorname;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Postkarten-Landing /pages/priority',
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: 'list', id: LIST_ID } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(PUBLIC_KEY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo HTTP ' + res.status);
      if (formBlock && successBlock) {
        formBlock.hidden = true;
        successBlock.hidden = false;
      }
    }).catch(function (err) {
      console.error('JC-Priority: Subscribe fehlgeschlagen', err);
      if (btn) btn.disabled = false;
      showError(({ nl: "Er is iets misgegaan. Probeer het opnieuw.", en: "Something went wrong. Please try again.", fr: "Une erreur s’est produite. Veuillez réessayer.", it: "Si è verificato un errore. Riprova.", sv: "Något gick fel. Försök igen.", pl: "Coś poszło nie tak. Prosimy spróbować ponownie." }[document.documentElement.lang.toLowerCase().split('-')[0]] || "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."));
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
